import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Heading, ModalConfirmContent } from '@restworld/ui-ds-base';
import { GreenCheckMarkWithWhiteBg } from '@restworld/utils-common';

import { StepWrapper } from '../job-explorer-save-research-v2';

export const ResearchSaveSuccessMessage = () => {
  const { t } = useTranslation('job-explorer-page');
  return (
    <StepWrapper>
      <ModalConfirmContent
        title={t('now_you_wont_miss_a_single_opportunity')}
        subtitle={t('avoid_missing_out_on_news_we_recommend')}
        icon={<GreenCheckMarkWithWhiteBg />}
        align="left"
      />
      {/* Separate sibling of ModalConfirmContent — StepWrapper adds no spacing, so give it a top
          gap (master's Title carried its own). Icon needs an explicit width + shrink-0; h-6 with
          no width rendered oversized next to the small muted text. */}
      {/* text-gray-400 on the span tints the icon (currentColor); Heading gets the same to match
          master's Title textColor="gray-400". (Heading color="muted" was gray-500 — too dark.) */}
      <span className="flex flex-row items-center gap-1.5 mt-6 text-gray-400" data-cy="view-saved-research">
        <InformationCircleIcon className="h-5 w-5 shrink-0" />
        <Heading size={6} weight="normal" className="text-gray-400">
          {t('view_save_search')}
        </Heading>
      </span>
    </StepWrapper>
  );
};

export default ResearchSaveSuccessMessage;
